import { Button, Menu, MenuButton, MenuItem, MenuList } from '@revelio/ui';

import styles from './GranularitySelector.module.css';

interface GranularitySelectorProps<T> {
  options: T[];
  selected: T;
  onSelect: (item: T) => void;
  getKey: (item: T) => string;
  getLabel: (item: T) => string;
  isSelected: (item: T, selected: T) => boolean;
}

export const GranularitySelector = <T,>({
  options,
  selected,
  onSelect,
  getKey,
  getLabel,
  isSelected,
}: GranularitySelectorProps<T>) => {
  if (options.length <= 1) return null;

  return (
    <Menu>
      <MenuButton>
        <Button size="xs" variant="ghost" className={styles.trigger}>
          ▾
        </Button>
      </MenuButton>
      {/* Width floor lives in the CSS module (.menuList); the Radix surface
          still grows to fit longer option labels. */}
      <MenuList className={styles.menuList}>
        {options.map((item) => (
          <MenuItem
            key={getKey(item)}
            className={
              isSelected(item, selected) ? styles.itemSelected : undefined
            }
            onClick={() => onSelect(item)}
          >
            {getLabel(item)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
